import React, { useEffect, useState } from 'react'
import Loader from 'components/Loader'
import TooltipError from 'components/TooltipError'
import Link from 'components/Link'
import Price from 'components/Price'
import ProductQuantity from 'components/ProductQuantity'
import TagManagerService from 'services/TagManager'
import ProductFactory from 'factories/Products'
import { maxItemsOSM } from 'config'
import PropTypes from 'prop-types'
import CartAction from 'actions/Cart'
import { elipsis } from 'utils/index'
import PromotionQuantity from 'components/PromotionQuantity'
import CartService from 'services/Cart'
import notImage from 'images/foto_en_preparacion.png'
import style from './style.scss' //NOSONAR

let timer = null

const Product = (props) => {
    const { item, position } = props

    if (!item) return ''

    const [isLoading, setLoading] = useState(false)
    const [actionError, setActionError] = useState(false)
    const [vQuantity, setVQuantity] = useState(item.quantity)

    let vMaxItems = 0

    const productPrice = ProductFactory.orderItemPrices(item)
    let sellingPrice = productPrice ? productPrice.regular : 0
    let sellingPriceTcenco = item.sellingPriceTcenco / 100
    sellingPriceTcenco = sellingPriceTcenco < sellingPrice ? sellingPriceTcenco : sellingPrice

    if (item.maxItems) {
        item.maxItems = item.maxItems > maxItemsOSM ? maxItemsOSM : item.maxItems
        vMaxItems = item.maxItems - item.quantityTotal
    } else {
        vMaxItems = maxItemsOSM
    }

    useEffect(() => {
        setVQuantity(item.quantity)
    }, [item.quantity])

    const removeItem = () => {
        setLoading(true)

        TagManagerService.productClickCart(item, 'Mini Cart decrease quantity', position, sellingPrice)
        TagManagerService.removeCart(item, sellingPrice, 'Mini Cart decrease quantity')

        CartAction.removeItem(item.id, item.quantity).then(_validateError)
    }

    const _validateError = (orderForm) => {
        setTimeout(() => {
            if (!orderForm?.items) return false
            const haveItem = orderForm.items.filter((obj) => (obj.id === item.id ? obj : false)).filter(Boolean).length > 0
            if (!haveItem) return false
            setActionError(!orderForm || orderForm.isOld)
            setLoading(false)
        }, 0)

        return orderForm
    }

    const clickOutTooltip = () => {
        setActionError(false)
    }

    const _validationModalNotes = (itemData) => {
        if (itemData) {
            const productData = {
                id: itemData.id,
                name: itemData.name,
                imageUrl: itemData.imageUrl ? itemData.imageUrl : null,
                categories: itemData.productCategories ? Object.values(itemData.productCategories) : [],
            }
            CartService.dispatchModalNote(productData)
        }
    }

    const increaseQuantity = () => {
        const maxItems = item.maxItems
        let qtd = vQuantity
        qtd++

        if (qtd > maxItems) qtd = maxItems

        setVQuantity(qtd)
        clearTimeout(timer)

        timer = setTimeout(() => {
            _validationModalNotes(item)
            addToCart(item, qtd)

            const tagQuantity = qtd - item.quantity

            TagManagerService.productClickCart(item, 'Mini Cart increase quantity', position, sellingPrice)
            TagManagerService.miniQtyAdd(item, tagQuantity, sellingPrice, 'Mini Cart increase quantity')
        }, 500)
    }

    const decreaseQuantity = () => {
        let qtd = vQuantity
        qtd--

        if (qtd < 1) qtd = 1

        setVQuantity(qtd)
        clearTimeout(timer)

        timer = setTimeout(() => {
            addToCart(item, qtd)

            const tagQuantity = item.quantity - qtd

            TagManagerService.productClickCart(item, 'Mini Cart decrease quantity', position, sellingPrice)
            TagManagerService.miniQtyRemove(item, tagQuantity, sellingPrice, 'Mini Cart decrease quantity')
        }, 500)
    }

    const addToCart = (itemProduct, vQuantityProd) => {
        if (vMaxItems) {
            const diference = vMaxItems
            const addDiference = vQuantityProd - itemProduct.quantity

            if (addDiference > diference) {
                vQuantityProd = itemProduct.quantity + diference
            }

            if (vQuantityProd < 0) {
                vQuantityProd = 0
            }
        }

        setLoading(true)
        setVQuantity(itemProduct.quantity)

        CartAction.updateItem(itemProduct.id, itemProduct.quantity, vQuantityProd).then(_validateError)
    }

    return (
        <div className="minicartcontent-item">
            {isLoading && (
                <div className="minicartcontent-loader-content">
                    <Loader />
                </div>
            )}
            {actionError && (
                <TooltipError message="En este momento no podemos completar tu solicitud." clickOut={clickOutTooltip} />
            )}
            <Link to={item.detailUrl} className="minicartcontent-product-img">
                {item.imageUrl && <img src={item.imageUrl.replace('http://', 'https://')} alt={item.name} />}
                {!item.imageUrl && <img src={notImage} alt={item.name} />}
            </Link>
            <div className="minicartcontent-item-content">
                <div className="minicartcontent-item-info">
                    <Link to={item.detailUrl} className="minicartcontent-item-name">
                        {elipsis(item.name, 60)}
                    </Link>
                    <div className="minicartcontent-item-prices">
                        <span className="minicartcontent-item-price">
                            {sellingPrice > 0 && <Price price={sellingPrice} />}
                            {sellingPrice <= 0 && 'Sin stock'}
                        </span>
                        {sellingPrice > sellingPriceTcenco && (
                            <span className="minicartcontent-item-price tcenco">
                                <Price price={sellingPriceTcenco} />
                            </span>
                        )}
                    </div>
                </div>
                <div className="minicartcontent-item-actions">
                    <div className="minicartcontent-item-quantity">
                        <span className="minicartcontent-item-quantity-view">
                            <ProductQuantity quantity={vQuantity} item={item} />
                        </span>
                        <button
                            onClick={decreaseQuantity}
                            className={`font-icn minicartcontent-quantity-btn minus ${vQuantity === 1 ? ' disabled' : ''}`} />
                        <button
                            onClick={increaseQuantity}
                            className={`font-icn minicartcontent-quantity-btn plus ${vQuantity === item.quantity + vMaxItems ? ' disabled' : ''}`} />
                        <PromotionQuantity item={item} withFactory={false} />
                    </div>
                    <a button="type" className={'new-link minicartcontent-item-remove'} onClick={removeItem}>
                        Eliminar
                    </a>
                </div>
            </div>
        </div>
    )
}

Product.propTypes = {
    item: PropTypes.object,
    position: PropTypes.number,
}

export default Product
